import { useContext } from '@fipnooone/react-modal';
import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { Button, Icon } from '@/Components/UI';

interface ModalMessageProps {
    message: ReactNode;
    messageClassName?: string;
    list?: string[];
}

export const ModalMessage: FC<ModalMessageProps> = ({ list, message, messageClassName }) => {
    const modal = useContext();

    return (
        <div className="unsaved">
            <Icon name="close" size={20} onClick={() => modal.close()} />

            <h1 className={cn(messageClassName)}>{message}</h1>

            {list && (
                <div className="unsaved__list">
                    <span>{list.join(', ')}</span>
                </div>
            )}

            <Button color="brown" text="Ok" onClick={() => modal.close()} />
        </div>
    );
};
